import { useParams, useNavigate } from "react-router-dom";
import ROUTES from "../../../routes/constants";
import { useFileMonitor } from "./use-file-monitor";
import { useClientFiles } from "./use-client-files";
import { ClientInformation } from "../../client-config/data/types";

// eslint-disable-next-line import/prefer-default-export
export const useFileMonitorLogic = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const navigate = useNavigate();

  const selectedClientId = clientId ? Number.parseInt(clientId, 10) : null;

  const list = useFileMonitor();
  // Starts loading the client's files straight away, alongside the client
  // list, rather than waiting for the list to arrive first.
  const clientFiles = useClientFiles(selectedClientId);

  const selectedClient: ClientInformation | null =
    selectedClientId !== null
      ? (list.clients?.find((c) => c.id === selectedClientId) ?? null)
      : null;

  const handleRefresh = () => {
    list.mutate();
    if (selectedClientId !== null) {
      clientFiles.mutate();
    }
  };

  const handleViewClient = (client: ClientInformation) => {
    navigate(`${ROUTES.ADMIN.FILE_MONITOR}/clients/${client.id}`);
  };

  const handleBackToList = () => {
    navigate(ROUTES.ADMIN.FILE_MONITOR);
  };

  return {
    selectedClient,
    clients: list.clients,
    isLoading:
      list.isLoading || (selectedClientId !== null && clientFiles.isLoading),
    error: list.error ?? clientFiles.error,
    clientFiles: clientFiles.files,
    isLoadingMoreFiles: clientFiles.isLoadingMore,
    loadMoreFilesError: clientFiles.loadMoreError,
    expectedFileCount:
      selectedClientId !== null
        ? (clientFiles.totalCount ?? list.getFileCount(selectedClientId))
        : null,
    handleRetryLoadingFiles: clientFiles.retry,
    handleRefresh,
    handleViewClient,
    handleBackToList,
    getFileCount: list.getFileCount,
  };
};
